export const name_validation = {
    name: 'name',
    label: 'Name',
    type: 'text',
    id: 'name',
    placeholder: 'Your name ...',
    validation: {
        required: {
            value: true,
            message: 'This field is required',
        },
        /*
        maxLength: {
            value: 30,
            message: '30 characters max',
        },
        */
    },
}

export const title_validation = {
    name: 'title',
    label: 'Title',
    type: 'text',
    id: 'title',
    placeholder: 'Your title ...',
    validation: {},
}

export const desc_validation = {
    name: 'description',
    label: 'Description',
    multiline: true,
    id: 'description',
    placeholder: 'Write description ...',
    validation: {
        required: {
            value: true,
            message: 'This field is required',
        },
        maxLength: {
            value: 200,
            message: '200 characters max',
        },
    },
}

export const password_validation = {
    name: 'password',
    label: 'Password',
    type: 'password',
    id: 'password',
    placeholder: 'Your password',
    validation: {
        required: {
            value: true,
            message: 'This field is required',
        },
        minLength: {
            value: 6,
            message: 'Min length is 6 characters',
        },
    },
}

export const num_validation = {
    name: 'num',
    label: 'number',
    type: 'number',
    id: 'num',
    placeholder: 'write a number',
    validation: {
        required: {
            value: true,
            message: 'This field is required',
        },
    },
}

export const email_validation = {
    name: 'email',
    label: 'Email',
    type: 'email',
    id: 'email',
    placeholder: 'Your email addresss',
    validation: {
        required: {
            value: true,
            message: 'This field is required',
        },
        pattern: {
            value:
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|((([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,})|localhost))$/,
            message: 'Enter valid email address',
        },
    },
}

const currentYear = new Date().getFullYear();

export const year_validation = {
    name: 'year',
    label: 'Year',
    type: 'number',
    id: 'year',
    placeholder: 'Your year',
    validation: {
        required: {
            value: true,
            message: 'This field is required',
        },
        min: {
            value: 1900,
            message: 'Year must be 1900 or later'
        },
        max: {
            value: currentYear,
            message: `Year cannot be later than ${currentYear}`
        },
        pattern: {
            value: /^(19|20)\d\d$/,
            message: 'Enter valid year (YYYY)',
        },
    },
}

export const date_validation = {
    name: 'date',
    label: 'Date',
    type: 'date',
    id: 'date',
    placeholder: 'Your date',
    validation: {
        required: {
            value: true,
            message: 'This field is required',
        },
        pattern: {
            value:
            /^(19|20)\d\d-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/,
            message: 'Enter valid date (YYYY-MM-DD)',
        },
    },
}

export const url_validation = {
    name: 'url',
    label: 'Url',
    type: 'url',
    id: 'url',
    placeholder: 'Enter url',
    validation: {
        required: {
            value: true,
            message: 'This field is required',
        },
        pattern: {
            value: /^(https?:\/\/)?(www\.)?(instagram\.com|youtube\.com|x\.com|twitter\.com|tiktok\.com)(\/[^\s]*)?$/,
            message: 'Enter valid URL address',
        },
    },
}

export const framer_error = {
    initial: { opacity: 0, y: 10 },
    animate: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: 10 },
    transition: { duration: 0.2 },
}
